
import { DateTime } from "luxon";

export function FormateDateRow(date) {
    return date ? DateTime.fromISO(date).setZone('UTC').toFormat("dd MMM yyyy hh:mm a ") : "";
}

export function formatDateToISOString(dateStr) {
    const date = new Date(dateStr);
    return date.toISOString();
}

export function getBoolean (value) {
    if (value === null || value === undefined) return null;
    if (typeof value === 'boolean') return value;
    if (value === "true") return true;
    if (value === "false") return false;
}